module.exports = __webpack_public_path__ + "media/images/auth_3-3481106ec6efecbe8ab1b8fc61c77b94.jpg";